<template>
  <div class="navbar-banner">
    <tags-view
      ref="tags-view"
      :visited-views="visitedViews"
      :cached-views="cachedViews"
      :tags-cut="tagsCut"
      :all-menu="allMenu"
      :all-routes="allRoutes"
      @setVisitedView="setVisitedView"
      @refreshTagsActions="refreshTagsActions"
    />
  </div>
</template>

<script>
import TagsView from './components/TagsView/index'
import '../../../../lib/styles/components/Navbar.scss'

export default {
  name: 'Navbar',
  components: {
    TagsView
  },
  props: {
    // 菜单
    allMenu: {
      type: Array,
      default: () => []
    },
    // 所有菜单
    allRoutes: {
      type: Array,
      default: () => []
    },
    visitedViews: {
      type: Array,
      default: () => []
    },
    cachedViews: {
      type: Array,
      default: () => []
    },
    tagsCut: { // 多余菜单 额外显示
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      device: 'desktop'
    }
  },
  methods: {
    refreshTagsActions() {
      this.$emit('refreshTagsActions')
    },
    // 页签
    setVisitedView(arr) {
      this.$emit('setVisitedView', arr)
    },
    // 页签缓存
    setCachedViews(arr) {
      this.$emit('setCachedViews', arr)
    }
  }
}
</script>
